<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3333 7.88558L8.66665 7.88558" stroke="#93939F" stroke-width="0.666667" stroke-linecap="round"/>
<path d="M12 6.21891L12 9.55224" stroke="#93939F" stroke-width="0.666667" stroke-linecap="round"/>
<path d="M5.33331 7.86198L3.44769 9.74759" stroke="#93939F" stroke-width="0.666667" stroke-linecap="round"/>
<path d="M5.33331 7.88558L3.4477 5.99996" stroke="#93939F" stroke-width="0.666667" stroke-linecap="round"/>
<path d="M5.33331 7.88558L2.66665 7.88558" stroke="#93939F" stroke-width="0.666667" stroke-linecap="round"/>
<circle cx="6.99996" cy="7.88558" r="1.33333" transform="rotate(-180 6.99996 7.88558)" stroke="#93939F" stroke-width="0.666667"/>
</svg>
